import '@babel/polyfill';
import '@babel/plugin-syntax-dynamic-import';
import * as conditioner from 'conditioner-core/conditioner-core.min';
import './polyfill/arrayFrom';
import './polyfill/arrayFind';
import './polyfill/dataset';

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

import SmoothScroll from './modules/smoothscroll';

const BODY = document.querySelector('body');
const SECTIONS = document.querySelectorAll(".strate[id]");
const HEADER_LINKS = document.querySelectorAll("header a");
const SCROLL_BAR = document.querySelector('#myBar');

window.disableScroll = false;
window.yOffset = 0;


window.addEventListener("DOMContentLoaded", () => {

    //parallax
    const pars = document.querySelectorAll('.par');

    for (const par of pars) {

        const gravity = par.getAttribute('data-gravity') || -60;
        const parent_selector = par.getAttribute('data-parent') || false;


        if(parent_selector){
            parent_selector = '.' + parent;
        } else {
            parent_selector = '.strate';
        }

        var anim = gsap.to(par, {
            yPercent: gravity,
            ease: "none",
            scrollTrigger: {
                trigger: par.closest(parent_selector),
                scrub: true
            },
        });
    }

    const LINKS = document.querySelectorAll('a');

    for (const link of LINKS) {
        const href = link.getAttribute('href');

        if (href.charAt(0) == '#' && href.length > 1) {

            const id = href.replace('#', '');

            const el = document.querySelector('#' + id);

            if (el) {
                link.addEventListener('click', (e) => {
                    e.preventDefault();

                    var offset = window.pageYOffset;

                    offset += el.getBoundingClientRect().top;
                    offset -= 20;

                    window.scrollTo(0, offset);
                })
            }
        }
    }

    // SmoothScroll(scrollY => {});

    setTimeout(function() {
        BODY.classList.add('loaded');
    }, 500); 

    setTimeout(function() {
        document.documentElement.className = 'js';
        conditioner.addPlugin({
            monitor: {
                name: 'visible',
                create: (context, element) => ({
                    matches: false,
                    addListener(change) {
                        new IntersectionObserver((entries) => {
                            this.matches = entries.pop().isIntersecting === context;
                            change();
                        }).observe(element);
                    },
                }),
            },

            moduleSetName: (name) => `./modules/${name}.js`,
            moduleGetConstructor: (module) => module.default,
            moduleImport: (name) => import(/* webpackMode: "lazy" */ `${name}`),
        });

        conditioner.hydrate(document.documentElement);

        window.addEventListener('scroll', scrollEvents);

        // scroll
        
    }, 700); 
});

function scrollEvents() {
    
  var winScroll = document.body.scrollTop || document.documentElement.scrollTop;
  var height = document.documentElement.scrollHeight - window.innerHeight;
  var scrolled = (winScroll / height) * 100;

  SCROLL_BAR.style.width = scrolled + "%";

    var current = false;
    var tmp = "";

    SECTIONS.forEach((section) => {
        const sectionTop = section.offsetTop;

        if (pageYOffset >= sectionTop - 20) {
            current = section.getAttribute('id');
        }
    });

    if (tmp !== current) {
        HEADER_LINKS.forEach((link) => {
            link.classList.remove("active");
            
            if (link.getAttribute('href') == "#" + current) {
                link.classList.add("active");
            }
        });
    }
}
